import styled, { css } from 'styled-components';
import { Icon, Link, Theme } from '@amzn/storm-ui';
import { BANNER_TYPE } from '@amzn/aac-chrome-internal-api';

interface BannerIconProps {
  variant: BANNER_TYPE;
  theme: Theme;
  isVerticallyCentered?: boolean;
}

export const ModalBannerListItem = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.xsmall.default} 0;
  border-bottom: 1px solid #e7e7e7;

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-of-type {
    padding-top: 0;
  }

  &&& a {
    color: ${({ theme }) => theme.color.lightBlue[700]};
  }
`;

export const ModalBannerListItemContent = styled.div`
  margin-inline-start: 16px;
`;

export const BannerIcon = styled(Icon)<BannerIconProps>`
  display: flex;
  justify-content: center;
  align-items: ${({ isVerticallyCentered }) =>
    isVerticallyCentered ? 'center' : 'flex-start'};
  min-width: 18px;
  color: ${({ variant, theme }) =>
    variant === BANNER_TYPE.ERROR
      ? theme.color.red[800]
      : variant === BANNER_TYPE.WARNING
        ? theme.color.orange[500]
        : theme.color.lightBlue[800]};
  margin-top: ${({ theme, isVerticallyCentered }) =>
    isVerticallyCentered ? '0' : theme.spacing.xxxsmall.default};
  padding-left: ${({ variant }) =>
    variant === BANNER_TYPE.ERROR ? '2px' : '0'};
`;

export const BannerContentWrapper = styled.div<{
  isRenderedInModal: boolean;
}>`
  display: flex;
  flex-direction: ${({ isRenderedInModal }) =>
    isRenderedInModal ? 'column' : 'row'};
  justify-content: center;
`;

export interface BannerLinkProps {
  isRenderedInModal: boolean;
}

export const BannerLink = styled(Link)<BannerLinkProps>`
  ${({ isRenderedInModal }) =>
    !isRenderedInModal &&
    css`
      margin-inline: ${({ theme }) =>
        `${theme.spacing.xxxsmall.default} ${theme.spacing.xxsmall.default}`};
    `};
  white-space: nowrap;
`;
